import { render, staticRenderFns } from "./PracticesTable.vue?vue&type=template&id=f4bcf85c"
import script from "./PracticesTable.vue?vue&type=script&lang=ts"
export * from "./PracticesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports